/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReleaseEntryStatus {
    Processing = '0',
    Successful = 1,
    Failed = 2,
    Abandoned = 3,
}
